<template>
  <v-app>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title> Filtros de búsqueda </v-card-title>
          <v-card-text>
            <v-row>
              <v-col>
                <v-text-field label="Nombre" v-model="form.name" />
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="green" dark @click="getData">
              <v-icon left> mdi-magnify </v-icon>
              Buscar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <v-col cols="12">
        <v-card>
          <v-simple-table>
            <thead>
              <tr>
                <th>Nombre</th>
                <th>Opciones</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="recommendation in recommendations"
                :key="recommendation.id"
              >
                <td>{{ recommendation.name }}</td>
                <td>
                  <v-btn
                    class="warning"
                    fab
                    small
                    dark
                    @click="edit(recommendation)"
                  >
                    <v-icon>mdi-circle-edit-outline</v-icon>
                  </v-btn>
                  <v-btn
                    class="red"
                    fab
                    small
                    dark
                    @click="showPDF(recommendation)"
                  >
                    <v-icon>mdi-file-pdf</v-icon>
                  </v-btn>
                  <v-btn
                    class="red"
                    fab
                    small
                    dark
                    @click="remove(recommendation)"
                  >
                    <v-icon>mdi-trash-can-outline</v-icon>
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-simple-table>
        </v-card>
      </v-col>
    </v-row>
    <v-fab-transition>
      <v-tooltip left>
        <template v-slot:activator="{ on }">
          <v-btn
            fab
            fixed
            bottom
            right
            color="primary"
            dark
            v-on="on"
            @click="modalNew = !modalNew"
          >
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </template>
        <span>Nueva recomendación</span>
      </v-tooltip>
    </v-fab-transition>
    <New :modal="modalNew" @close-modal="closeModalNew" />
    <Edit
      :modal="modalEdit"
      :recommendation="recommendation"
      @close-modal="closeModalEdit"
    />
    <PDF :modal="modalPDF" :path="pdfPath" @close-modal="modalPDF = false" />
  </v-app>
</template>

<script scoped>
import New from "./New";
import Edit from "./Edit";
import PDF from "./PDF";
export default {
  components: { New, Edit, PDF },
  data() {
    return {
      modalNew: false,
      modalEdit: false,
      modalPDF: false,
      form: {},
      recommendations: [],
      recommendation: {},
      pdfPath: "",
    };
  },
  methods: {
    closeModalNew() {
      this.modalNew = false;
    },
    closeModalEdit() {
      this.modalEdit = false;
      this.getData();
    },
    getData() {
      this.openLoader();
      window.setTimeout(() => {
        const request = this.sendRequest(
          this.$store.state.apiUrl + "catalogs/recommendations",
          this.form
        );
        request
          .then(({ data }) => {
            this.recommendations = data;
          })
          .finally(() => this.closeLoader());
      }, 200);
    },
    edit(recommendation) {
      this.recommendation = recommendation;
      this.modalEdit = true;
    },
    showPDF(recommendation) {
      this.pdfPath =
        this.$store.state.baseApiUrl +
        `/files/catalogs/recommendations/${
          recommendation.name
        }.pdf?_=${Date.now()}`;
      this.modalPDF = true;
    },
    remove(recommendation) {
      window.setTimeout(async () => {
        try {
          await this.deleteRequest(
            `catalogs/recommendations/${recommendation.id}`
          );
          this.getData();
        } catch (e) {
          this.showErrorMessage(e.message);
        }
      }, 200);
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
